import { render } from "./PackageDistanation.html?vue&type=template&id=58f44af5"
import script from "./PackageDistanation.js?vue&type=script&lang=js"
export * from "./PackageDistanation.js?vue&type=script&lang=js"

import "./PackageDistanation.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__